import { render } from "./offresCommerciales.vue?vue&type=template&id=aa535268"
import script from "./offresCommerciales.vue?vue&type=script&lang=ts"
export * from "./offresCommerciales.vue?vue&type=script&lang=ts"
script.render = render

export default script